/* eslint-disable no-empty */
import { html, LitElement } from 'lit-element';
import autoResize from '@giswebgroup/ki-wcp-base/src/decorators/autoResize';
import LoaderMixin from '@giswebgroup/ki-wcp-base/src/common/LoaderMixin';
import moment from 'moment/moment';
import i18n from '@giswebgroup/ki-wcp-base/src/decorators/i18n';
import nls from '../../locales/index.nls';
import style from './ki-station-data-download-form.css';
import '@giswebgroup/ki-wcp-base/src/components/ki-switcher/ki-switcher';
import {readCookie } from '@giswebgroup/ki-wcp-base/src/common/util';
import './time-range-picker';
import './switcher';

// TODO

export default
@autoResize()
@i18n(nls)
class KiStationDataDownloadForm extends LoaderMixin(LitElement) {
  // language=CSS
  static styles = style;

  static get properties() {
    return {
      downloadOptions: { type: Object },
    };
  }
  // this.i18n.t('last_measure_time')

  render() {
    return html`
      <form class="form-container">
        <div class="input-container">
          <div class="label">Nom et prénom</div>
          <div><input type="text" class="input" id="name"  @change="${this.validate}" /></div>
          <div class="line-seperate"></div>
          <div class="label">Votre Email</div>
          <div><input type="email" class="input" id="email"  @change="${this.validate}" /></div>
          <div class="line-seperate"></div>
          <div class="label">Société, Organisme</div>
          <div><input type="text" class="input" id="orgnization" @change="${this.validate}" /></div>
          <div class="line-seperate"></div>
          <div class="label">Objet de l’utilisation des données</div>
          <div><textarea class="input textArea" id="purpose" @change="${this.validate}"></textarea></div>
          <div class="line-seperate"></div>
          <div class="label">Date de début et de fin de la période souhaitée</div>
          <div><time-range-picker id="period" allowtimebox="true" ></time-range-picker></div>
          <div class="line-seperate"></div>
          <div class="label">${this.i18n.t('DataType')}</div>
          <div>
            <ki-switcher id="dataType"></ki-switcher>
          </div>
          <div class="line-seperate"></div>
          <div class="label">Télécharger au format</div>
          <div>
            <ki-switcher id="downloadFormat" ></ki-switcher>
          </div>
          <div class="line-seperate"></div>
          <div>
            <span><ki-checkbox @change="${this.validate}"  id="acceptTerms" class="kiCheckBox"></ki-checkbox></span>
            <span>${this.i18n.t('acceptTerms')}</span>
          </div>
        </div>
      </form>
      <div class="actions">
        <mwc-button  @click="${this.closedialog}"> ${this.i18n.t('Cancel')} </mwc-button>
        <mwc-button id="sendButton" disabled @click="${this.requestdata}"> ${this.i18n.t('Submit')} </mwc-button>
      </div>

    `;
  }

  validate(){
    const sendButton = this.renderRoot.querySelector('#sendButton');
    const name = this.renderRoot.querySelector('#name');
    const email = this.renderRoot.querySelector('#email');
    const acceptTerms = this.renderRoot.querySelector('#acceptTerms');
    const period = this.renderRoot.querySelector('#period');
    const purpose = this.renderRoot.querySelector('#purpose');
    const orgnization = this.renderRoot.querySelector('#orgnization');
    if(name.value && email.checkValidity() && acceptTerms.checked && orgnization.value && purpose.value){
      sendButton.disabled = false;
    }else{
      sendButton.disabled = true;
    }
  }

  requestdata(){
    this.dispatchEvent(
      new CustomEvent('datarequest', {
        bubbles: true,
        composed: true,
      }),
    );
  }

  reset(){
    const userinfo = readCookie("userpersonalinfo");
    if(!userinfo){
      this.renderRoot.querySelector('#name').value ="";
      this.renderRoot.querySelector('#email').value ="";
      this.renderRoot.querySelector('#purpose').value ="";
      this.renderRoot.querySelector('#orgnization').value ="";
      this.renderRoot.querySelector('#acceptTerms').checked =false;
    }
  }

  closedialog(){
    this.reset();
    this.dispatchEvent(
      new CustomEvent('closedialog', {
        bubbles: true,
        composed: true,
      }),
    );
  }

  getValues() {
    const formData = {};
    const name = this.renderRoot.querySelector('#name');
    if(!name.value){
      return false;
    }
    formData.name = this.renderRoot.querySelector('#name').value;
    formData.email = this.renderRoot.querySelector('#email').value;
    formData.orgnization = this.renderRoot.querySelector('#orgnization').value;
    formData.purpose = this.renderRoot.querySelector('#purpose').value;
    const period = this.renderRoot.querySelector('#period');
    formData.from = period.fromDate.dateSelected ? moment(period.fromDate.dateSelected).format() : '';
    formData.to = period.toDate.dateSelected ? moment(period.toDate.dateSelected).format() : '';
    formData.dataType = this.renderRoot.querySelector('#dataType').value;
    formData.downloadFormat = this.renderRoot.querySelector('#downloadFormat').value;
    formData.acceptTerms = this.renderRoot.querySelector('#acceptTerms').checked;

    return formData;
  }

  firstUpdated() {
    super.firstUpdated();
    const dataType = this.renderRoot.querySelector('#dataType');
  
  
    const dataDefaultOptions = {
        "returnfields": "Timestamp,Value",
        "items": [
          { label: this.i18n.t('DailyData'), value: ["Day.Mean"] },
          { label: this.i18n.t('HourlyData'), value: ["h.Mean"] },
          { label: this.i18n.t('HighResData'), value: ['Cmd.Rel.Abs.Comp-Alarmes'] 
        },
        ]
    };
    dataType.options = this.downloadOptions ? this.downloadOptions.items : dataDefaultOptions.items;
    this.returnfields=  this.downloadOptions ? this.downloadOptions.returnfields : dataDefaultOptions.returnfields;
    const downloadFormat = this.renderRoot.querySelector('#downloadFormat');
    downloadFormat.options = [
      { label: 'XLSX', value: 'xlsx' },
      { label: 'Zrxp', value: 'zrxp' },
      { label: 'WML2', value: 'wml2' },
    ];

    const userinfo = readCookie("userpersonalinfo");
    if(userinfo){
      try {
        const val = JSON.parse(atob(userinfo));
        console.log(val);
        if(val.email){
          this.renderRoot.querySelector('#email').value = val.email;
        }
        if(val.name){
          this.renderRoot.querySelector('#name').value = val.name;
        }
        if(val.organisation){
          this.renderRoot.querySelector('#orgnization').value = val.organisation;
        }
      }catch(e){
        console.error("error reading userpersonalinfo");
      }
    }
    const period = this.renderRoot.querySelector('#period');
    period.to = moment();
    period.from = moment().subtract(15, "days");
    this.requestUpdate();
  }
}
customElements.define('ki-station-data-download-form', KiStationDataDownloadForm);
